import Button from '@stone/ui/button/Button';
import classNames from 'classnames';
import React from 'react';
const ClientServiceSection = (props) => {
    const { title, description, introSection, className, buttonLink, buttonText, children, borderBottom, buttonAction, noMargin, noPadding } = props;
    const textHolder = React.createElement(React.Fragment, null, title && React.createElement("h2", { className: "section__title" }, title));
    if (!props.active) {
        return React.createElement(React.Fragment, null, props.children);
    }
    const renderTitle = !!title || !!buttonLink || !!buttonAction;
    return (React.createElement("section", { className: classNames('client-service__section', {
            'section--intro-section': introSection,
            'section--title-only': !description && !children,
            'section--little-snippet': buttonLink || buttonAction,
            'section--border-bottom': borderBottom,
            'section--no-margin': noMargin,
            'section--no-padding': noPadding,
        }, className != undefined && className) },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row section__content" },
                renderTitle && (React.createElement("div", { className: "col-24 col-lg-5 col-xxl-4 first-col" }, buttonLink || buttonAction ? (React.createElement(React.Fragment, null,
                    React.createElement("div", null, textHolder),
                    buttonAction ? (React.createElement(Button, { type: "button", cls: ['button--secondary'], onClick: buttonAction },
                        React.createElement("span", null, buttonText))) : (React.createElement("a", { href: buttonLink, target: "_blank", className: "button button--secondary" },
                        React.createElement("span", null, buttonText))))) : (textHolder))),
                React.createElement("div", { className: classNames('col-24 col-lg-14 col-xxl-12 last-col', { 'offset-lg-5 offset-xxl-6': !renderTitle }, { 'offset-xxl-2': renderTitle }) }, children)))));
};
ClientServiceSection.defaultProps = {
    active: true,
};
export default ClientServiceSection;
